import { Component, Output, EventEmitter, Input } from '@angular/core';
import { CdkStepper, CdkStepperNext, CdkStepperPrevious } from '@angular/cdk/stepper';
import {PageContainerComponent} from "../page-container/page-container.component";
import { NgClass, NgTemplateOutlet } from "@angular/common";
import { ButtonComponent } from '../button/button.component';

@Component({
    selector: 'gbc-stepper',
    templateUrl: './stepper.component.html',
    styleUrls: ['./stepper.component.scss'],
    providers: [{ provide: CdkStepper, useExisting: StepperComponent }],
    imports: [PageContainerComponent, NgClass, NgTemplateOutlet, ButtonComponent, CdkStepperPrevious, CdkStepperNext]
})
export class StepperComponent extends CdkStepper {
  @Input() backLabel: string;
  @Input() nextLabel: string;
  @Input() doneLabel: string;

  @Input() backDisabled: boolean = false;
  @Input() nextDisabled: boolean = false;
  @Input() doneDisabled: boolean = false;

  @Output() done = new EventEmitter<void>();
}
